export default [
  {
    path: "/reservation",
    meta: { hideAppBar: true, fullWidth: true },
    name: "ReservationTypeSelection",
    component: () => import("@/views/reservationTool/views/ReservationTypeSelection.vue"),
  },

  {
    path: "/reservation/:reservationTypeId",
    name: "ReservationBooking",
    meta: { hideAppBar: true, fullWidth: true },
    component: () => import("@/views/reservationTool/ReservationTool.vue"),
  },
]
